// Third-party
import React from 'react';
import classNames from 'classnames';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import {
  passwordHasLowerCase,
  passwordHasMinLength,
  passwordHasNumber,
  passwordHasSpecialChar,
  passwordHasUpperCase,
  passwordMeetsComplexityReq,
  PASSWORD_MIN_COMPLEXITY_CHECKS,
} from '../../../utils/auth';

type Props = {
  password: string;
  confirm: string;
};

const LegacyPasswordCriteria = ({ password, confirm }: Props) => {
  const getCriteriaClassName = (validator: (value: string) => boolean) => (validator(password) ? 'success' : 'error');

  return (
    <div className="legacy-password-criteria">
      <div>
        <div className={classNames('criteria', getCriteriaClassName(passwordHasMinLength))}>
          <FormattedMessage id="Auth.SetPassword.Criteria.Length" />
        </div>

        <div
          className={classNames(
            'criteria',
            getCriteriaClassName(value => !!value && value === confirm),
          )}
        >
          <FormattedMessage id="Auth.SetPassword.Criteria.Match" />
        </div>
      </div>

      <div>
        <div className={classNames('criteria', getCriteriaClassName(passwordMeetsComplexityReq))}>
          <FormattedMessage id="Auth.SetPassword.Criteria.ComplexityRequirements" values={{ count: PASSWORD_MIN_COMPLEXITY_CHECKS }} />
        </div>

        <ul>
          <li className={classNames('criteria sub-criteria', getCriteriaClassName(passwordHasLowerCase))}>
            <FormattedMessage id="Auth.SetPassword.Criteria.LowerCase" />
          </li>

          <li className={classNames('criteria sub-criteria', getCriteriaClassName(passwordHasUpperCase))}>
            <FormattedMessage id="Auth.SetPassword.Criteria.UpperCase" />
          </li>

          <li className={classNames('criteria sub-criteria', getCriteriaClassName(passwordHasNumber))}>
            <FormattedMessage id="Auth.SetPassword.Criteria.Number" />
          </li>

          <li className={classNames('criteria sub-criteria', getCriteriaClassName(passwordHasSpecialChar))}>
            <FormattedMessage id="Auth.SetPassword.Criteria.SpecialChar" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LegacyPasswordCriteria;
